// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_bv-0";
export var headerCellHover = "_bv-1";
export var readCellContainer = "_bv-2";
export var readCellSlot = "_bv-3";
export var rowHoverCheckbox = "_bv-4";
export var rowUnreadIndicator = "_bv-5";
export var searchHighlight = "_bv-8";
export var summaryCellHoverWrapper = "_bv-9";
export var supportTicketRow = "_bv-6";
export var unreadIndicator = "_bv-7";